import { CardContent, withStyles } from '@material-ui/core';

const StyledCardContent = withStyles(() => ({
  root: {
    padding: '0 1rem 2rem  1rem',
  },
}))(CardContent);

export default StyledCardContent;
